// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"d33b3588","40":"54e5a03d","66":"8e6875aa","95":"8528f74e","821":"7d84abe4","931":"3cd972b4"}[chunkId] + ".chunk.js";
};